const ProductType = {
  Savings: 'savings',
  FixedDeposit: 'fixed-deposit',
  SharedCapital: 'shared-capital'
};

export default ProductType;
